import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Play, ShieldCheck } from 'lucide-react';
const CALENDLY_URL = 'https://calendly.com/vantixcredit/diagnostico-de-credito';
export function Hero() {
  const [isPlaying, setIsPlaying] = useState(false);
  return <section className="relative bg-black min-h-screen flex items-center pt-32 pb-20 px-4 sm:px-6 lg:px-8 overflow-hidden" data-id="element-132" data-mp="4lyx6rdz8oga">
      {/* Subtle radial glow background */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(245,158,11,0.08),transparent_60%)] pointer-events-none" data-id="element-133" data-mp="127edlbj0jlce" />

      <div className="relative z-10 max-w-7xl mx-auto w-full grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-134" data-mp="sart4nulmwaw">
        {/* Left: copy + CTA */}
        <div className="text-center lg:text-left" data-id="element-135" data-mp="neavn31if5l5">
          <motion.h1 initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 1,
          delay: 0.1,
          ease: [0.16, 1, 0.3, 1]
        }} className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-[1.08] tracking-tight mb-6" data-id="element-136" data-mp="3d2lb3gldnd2t">
            Restaura tu crédito y accede a{' '}
            <span className="italic font-black bg-gradient-to-b from-amber-200 via-amber-400 to-amber-600 bg-clip-text text-transparent" data-id="element-137" data-mp="3e8mqgsg72bbg">
              más de $50,000 en financiamiento
            </span>
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.9,
          delay: 0.25,
          ease: [0.16, 1, 0.3, 1]
        }} className="text-lg md:text-xl text-white/50 font-light leading-relaxed mb-10 max-w-xl mx-auto lg:mx-0" data-id="element-138" data-mp="35aas2493698g">
            Removemos las cuentas negativas de tu reporte, estructuramos tu
            perfil y te conseguimos el capital. Todo hecho por nosotros, con
            garantía por escrito a 120 días.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.4,
          ease: [0.16, 1, 0.3, 1]
        }} className="flex flex-col items-center lg:items-start gap-5" data-id="element-139" data-mp="ibgiwm6935g0">
            <a href={CALENDLY_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-gradient-to-b from-amber-300 via-amber-400 to-amber-600 hover:brightness-110 text-black font-semibold px-8 py-4 rounded-full transition-all text-lg shadow-2xl shadow-amber-500/25" data-id="element-140" data-mp="111esx7tlz8ma">
              Agenda tu diagnóstico gratis de 40 min
              <ArrowRight className="h-5 w-5" data-id="element-141" data-mp="1xb5p0bw6inf2" />
            </a>

            <div className="flex items-center gap-2.5 text-sm text-white/40 font-light" data-id="element-142" data-mp="21by0zcwfr6f1">
              <ShieldCheck className="h-4 w-4 text-amber-400/80" data-id="element-143" data-mp="269r3nvyj5iak" />
              Sin costo · Sin compromiso · Garantía de 120 días
            </div>
          </motion.div>
        </div>

        {/* Right: video */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.96,
        y: 30
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} transition={{
        duration: 1.1,
        delay: 0.35,
        ease: [0.16, 1, 0.3, 1]
      }} id="vsl" data-id="element-144" data-mp="2fyr83uvsx5w5">
          <div className="relative aspect-video rounded-3xl overflow-hidden bg-[#111] shadow-2xl shadow-amber-500/10 ring-1 ring-white/10" data-id="element-145" data-mp="umzfvosefs46">
            {!isPlaying ? <>
                <div className="absolute inset-0 bg-cover bg-center" style={{
              backgroundImage: "url('https://cdn.magicpatterns.com/uploads/iscmunNCTmj2gaCHihABZz/Captura_de_pantalla_2026-06-01_a_la(s)_9.56.15_p.m..png')"
            }} data-id="element-146" data-mp="4b48dwosual1" />
                <div className="absolute inset-0 bg-black/50" data-id="element-147" data-mp="9bs6117j9po8" />

                <button onClick={() => setIsPlaying(true)} className="absolute inset-0 flex items-center justify-center group/play" aria-label="Reproducir video" data-id="element-148" data-mp="3hpr202ui9b1q">
                  <div className="relative" data-id="element-149" data-mp="3rgvgl1g9qtw1">
                    <div className="absolute inset-0 rounded-full bg-amber-400/30 animate-ping" data-id="element-150" data-mp="3mpdh6htw91d6" />
                    <div className="relative h-20 w-20 rounded-full bg-gradient-to-b from-amber-300 via-amber-400 to-amber-600 flex items-center justify-center group-hover/play:scale-110 transition-transform duration-300 shadow-2xl shadow-amber-500/40" data-id="element-151" data-mp="2yzsvvsa9ps0q">
                      <Play className="h-8 w-8 text-black fill-black ml-1" data-id="element-152" data-mp="19hvq4zn219dk" />
                    </div>
                  </div>
                </button>
              </> : <iframe src="https://player.vimeo.com/video/1197541389?autoplay=1&title=0&byline=0&portrait=0" className="absolute inset-0 w-full h-full" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture" allowFullScreen title="Vantix Credit Solutions" data-id="element-153" data-mp="zliwg1rievit" />}
          </div>
          <p className="mt-4 text-center text-sm text-white/40 font-light" data-id="element-154" data-mp="1j7fak9qf1baj">
            Mira en 3 minutos cómo funciona el proceso.
          </p>
        </motion.div>
      </div>
    </section>;
}